class ApiError extends Error {
  constructor(message, status, data = {}) {
    super(message); // Call parent Error constructor
    
    this.name = 'ApiError'; // Error type name
    this.status = status; // HTTP status code
    this.success = false;
    
    // Add any additional data from backend
    Object.assign(this, data);
    
    // Maintains proper stack trace (only in V8 engines like Chrome/Node)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }
}

export default ApiError;